/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createProductDtoFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type ProblemDetails, type ProductDto, type ValidationProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/RegulatoryCharacteristics/SetPrimary
 */
export interface SetPrimaryRequestBuilder extends BaseRequestBuilder<SetPrimaryRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ProductDto>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 429 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     post(requestConfiguration?: RequestConfiguration<SetPrimaryRequestBuilderPostQueryParameters> | undefined) : Promise<ProductDto | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<SetPrimaryRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface SetPrimaryRequestBuilderPostQueryParameters {
    characteristicCode?: string;
    culture?: string;
    productCode?: number;
}
/**
 * Uri template for the request builder.
 */
export const SetPrimaryRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/RegulatoryCharacteristics/SetPrimary{?characteristicCode*,culture*,productCode*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const SetPrimaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SetPrimaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createProductDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
